export const UPDATE_ACTUAL_ITINERARY_SEGMENT = 'UPDATE_ACTUAL_ITINERARY_SEGMENT'

export function actualItineraryPathSegmentReducer(state = -1, action) {
    switch (action.type){
        case UPDATE_ACTUAL_ITINERARY_SEGMENT:
            return action.payload
        default: return state
    }
}